import * as React from 'react';
export const VisibilityContext = React.createContext({
    isVisible: true,
});
export default class VisibilityProvider extends React.Component {
    render() {
        return (React.createElement(VisibilityContext.Provider, { value: this.props }, this.props.children));
    }
}
